"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFunction = exports.BaseService = void 0;
var BaseService;
(function (BaseService) {
    BaseService["files"] = "files";
})(BaseService = exports.BaseService || (exports.BaseService = {}));
var BaseFunction;
(function (BaseFunction) {
    BaseFunction["login"] = "login";
    BaseFunction["logout"] = "logout";
    BaseFunction["isAuthenticated"] = "isAuthenticated";
    BaseFunction["getUserId"] = "getUserId";
})(BaseFunction = exports.BaseFunction || (exports.BaseFunction = {}));
